module.exports = __webpack_public_path__ + "img/bar_progress.edf725d9.jpg";